<template>
  <div class="teaching-card-view">
    <template v-if="index == 0">
      <h4 style="margin-bottom: 15px;">履历{{index + 1}}</h4>
      <div v-if="index == 0" style="margin-bottom: 15px;font-size: 12px;color: #666;">
        （该履历为您的最新执教履历，将在协会认证教练员列表优先展示，没有可填“无”）
      </div>
    </template>
    <h4 v-else style="margin-bottom: 30px;">履历{{index + 1}}</h4>
    <div class="input-row" :id="'resume_' + item.uuid + '_unit_view'">
      <div class="column left-label">*执教单位：</div>
      <div class="column">
        <el-input :class="[ (noticed && !item.unit) ? 'red-border' : '']" v-model="item.unit" placeholder="请输入您的执教单位"
          clearable />
      </div>
    </div>

    <div class="input-row" :id="'resume_' + item.uuid + '_title_view'">
      <div class="column left-label">*执教职位：</div>
      <div class="column">
        <el-input :class="[ (noticed && !item.title) ? 'red-border' : '']" v-model="item.title" placeholder="请输入您的执教职位"
          clearable />
      </div>
    </div>

    <div class="input-row" :id="'resume_' + item.uuid + '_strBeginDate_view'">
      <div class="column left-label">*开始时间：</div>
      <div class="column">
        <el-date-picker clearable :class="[ (noticed && !item.strBeginDate) ? 'red-border' : '']" v-model="item.strBeginDate"
          :picker-options="pickerOptions" align="right" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
          placeholder="请选择日期">
        </el-date-picker>
      </div>
    </div>

    <div class="input-row" :id="'resume_' + item.uuid + '_strEndDate_view'">
      <div class="column left-label">*结束时间：</div>
      <div class="column">
        <el-date-picker clearable v-model="item.strEndDate" :picker-options="endPickerOptions" align="center" type="date"
          format="yyyy-MM-dd" value-format="yyyy-MM-dd" :class="item.strEndDate == '' ? 'now-time-picker' : ''"
          :placeholder="item.strEndDate == '' ? '至今' : '请选择日期'">
        </el-date-picker>
      </div>
    </div>

    <div class="input-row" :id="'resume_' + item.uuid + '_results_view'">
      <div class="column left-label">期间获得的成绩：</div>
      <div class="column">
        <el-input v-model="item.results" type="textarea" placeholder="请填写您期间获得的成绩,请控制字数" rows="5" clearable />
      </div>
    </div>

    <div class="input-row" :id="'resume_' + item.uuid + '_photos_view'">
      <div class="column left-label picture-upload-label">成绩证明材料：</div>
      <div class="column">
        <el-upload class="files-upload" action="https://api.shslqxh.com/upload/files" :headers="headers" name="files"
          :limit="fileLimit" :file-list="initialFileList" :accept="acceptTypes" list-type="picture-card"
          :on-exceed="handleExceed" :on-remove="handleFileRemove" :before-remove="beforeRemoveFile" :on-preview="handlePreview"
          :on-success="handleUploadSuccess">
          <i class="el-icon-plus"></i>
          <div slot="tip" class="el-upload__tip">请上传所有有效信息页。</div>
        </el-upload>
      </div>
    </div>
    <div v-if="index != 0"><a class="delete-button" href="javascript:void(0)" @click="deleteCardItem">删除</a></div>
    <image-preview-view v-if="dialogVisible" :picture-list="dialogImageModel.list" :initial-index="dialogImageModel.index"
      v-on:close="closeImagePreviewView" />
  </div>
</template>

<script>
  import ImagePreview from "../../../common/ImagePreview.vue";
  import PictureTool from "../../../../js/picture-tool.js";
  export default {
    name: "TeachingCardItemVue",
    props: {
      item: {
        type: Object,
        default: null,
      },
      index: {
        type: Number,
        default: 0,
      },
      noticed: {
        type: Boolean,
        default: false,
      }
    },
    components: {
      'image-preview-view': ImagePreview
    },
    data() {
      return {
        headers: {},

        dialogImageModel: null,
        dialogVisible: false,

        fileLimit: 20,
        pickerOptions: {
          disabledDate: (time) => {
            // console.log(time);
            return this.dealWithDisableStartDate(time);
          },
        },

        endPickerOptions: {
          disabledDate: (time) => {
            return this.dealWithDisableEndDate(time);
          },
          shortcuts: [{
            text: '至今',
            onClick(picker) {
              picker.$emit('pick', '');
            }
          }],
        },

        initialFileList: [],
      }
    },
    computed: {
      acceptTypes() {
        return PictureTool.acceptTypes;
      },
    },
    mounted() {
      let token = this.$store.state.dataStore.getToken();
      this.headers.token = token;
      this.initData();
    },
    methods: {
      closeImagePreviewView() {
        this.dialogVisible = false;
        this.dialogImageModel = null;
      },

      initData() {
        let item = this.item;
        if (item == null) {
          return;
        }
        let initialFileList = [];
        if (item != null && item.photos.length > 0) {
          for (let i = 0; i < item.photos.length; i++) {
            initialFileList.push(item.photos[i])
          }
        }
        this.initialFileList = initialFileList;
      },

      dealWithDisableStartDate(time) {
        let isAfterNow = this.dealDisableDate(time);
        if (isAfterNow) {
          return isAfterNow;
        }
        let endDate = this.item.strEndDate;
        if (endDate) {
          let endTime = this.$moment(endDate);
          let startTime = this.$moment(time);
          return endTime - startTime < 0;
        }
        return isAfterNow;
      },
      dealWithDisableEndDate(time) {
        let isAfterNow = this.dealDisableDate(time);
        if (isAfterNow) {
          return isAfterNow;
        }
        let startDate = this.item.strBeginDate;
        if (startDate) {
          let startTime = this.$moment(startDate);
          let endTime = this.$moment(time);
          return endTime - startTime < 0;
        }
        return isAfterNow;
      },

      dealDisableDate(time) {
        return new Date().getTime() - (new Date(time).getTime()) < 0;
      },

      beforeRemoveFile(file, fileList) {
        return this.$confirm(`确定移除当前照片吗？`);
      },
      handleExceed(files, fileList) {
        this.$message.warning(
          `当前限制选择 ${ this.fileLimit } 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      },
      handleFileRemove(file, fileList) {
        let url = file.response;
        if (url == undefined) {
          url = file.url;
        }
        let index = this.item.photos.findIndex(function(item) {
          return item.url == url;
        });
        this.item.photos.splice(index, 1);
        if (this.item.photos.length < this.fileLimit) {
          // $("#idverify_view_outer .files-upload .el-upload--picture-card").show();
        }
        // this.updatepassportPhotos();
      },
      handlePreview(file) {
        let url = file.response;
        if (url == undefined) {
          url = file.url;
        }
        let photos = this.item.photos;
        let index = photos.findIndex(function(item) {
          return item.url == url;
        });
        if (index == -1) {
          index = 0;
        }
        this.dialogImageModel = {
          list: photos,
          index
        };
        this.dialogVisible = true;
      },

      handleUploadSuccess(res, file) {
        if (typeof res == 'string') {
          let name = file.name;
          let url = res;
          let obj = {
            name,
            url
          };
          this.item.photos.push(obj);
          if (this.item.photos.length >= this.fileLimit) {
            // $("#idverify_view_outer .files-upload .el-upload--picture-card").hide();
          }
          // this.updatepassportPhotos();
        }
      },

      deleteCardItem() {
        let _this = this;
        this.$confirm('您正在进行删除操作，删除后信息不会保存，需重新填写', '提示', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          _this.$emit('deleteItem', {
            index: _this.index
          });
        }).catch(() => {
          //...取消
          // console.log('不退出');
        });
      },

    }
  }
</script>

<style scoped>
  @import url("../../../../css/input-row.css");

  .teaching-card-view {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
  }

  .teaching-card-view {
    margin-top: 50px;
  }

  .teaching-card-view:first-child {
    margin-top: 20px;
  }

  .teaching-card-view .delete-button {
    color: #999;
    text-decoration: underline;
  }

  .teaching-card-view .delete-button:hover {
    color: #23527c;
  }

  .teaching-card-view .now-time-picker {
    color: #333;
  }

  .teaching-card-view .now-time-picker>>>::-webkit-input-placeholder {
    color: #333;
  }
</style>



// WEBPACK FOOTER //
// src/components/personal/coachApplications/cards/TeachingCardItem.vue